var installedModules = {};
var moduleToHandlerMapping = {
	40395: {
		getter: () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	12062: {
		getter: () => (__webpack_require__.e(2026).then(() => (() => (__webpack_require__(42026))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "0.4.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "reflux",
	},
	13525: {
		getter: () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	19629: {
		getter: () => (__webpack_require__.e(2543).then(() => (() => (__webpack_require__(2543))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^4.17.21",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	36377: {
		getter: () => (Promise.all([__webpack_require__.e(6029), __webpack_require__.e(5358)]).then(() => (() => (__webpack_require__(95093))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.30.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "moment",
	},
	91135: {
		getter: () => (Promise.all([__webpack_require__.e(1376), __webpack_require__.e(7955)]).then(() => (() => (__webpack_require__(41376))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "~2.4.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-intl",
	},
	20821: {
		getter: () => (__webpack_require__.e(8989).then(() => (() => (__webpack_require__(28989))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^0.23.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router-bootstrap",
	},
	40632: {
		getter: () => (__webpack_require__.e(1553).then(() => (() => (__webpack_require__(91553))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	47763: {
		getter: () => (__webpack_require__.e(4179).then(() => (() => (__webpack_require__(24179))))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.2.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-router",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"395": [
		40395
	],
	"7263": [
		47763
	],
	"9622": [
		20821,
		40632
	],
	"9899": [
		12062,
		13525,
		19629,
		36377,
		91135
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}